import { API } from '@Providers';

interface Payload {
  entity: string;
  exclude_id?: string;
  field?: string;
  fields?: { name: string; value: string }[];
  value?: any;
  page?: number;
  per_page?: number;
  data_for_table?: boolean;
  return_do_not_adopt?: boolean;
}

export default async function (payload: Payload) {
  const endpoint = '/api/shelter/forms/checkDuplicate';

  return API({ endpoint, forwardError: true, method: 'post', payload }).then((result: any) => result);
}
